// Route: '/play/join/:sessionid/:gameid'
import React, { useContext, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Main } from '../../styles';
import Nav from '../../components/Nav/Nav';
import TextInput from '../../components/TextInput/TextInput';
import { StoreContext } from '../../utils/store';

const JoinPage = () => {
  const { sessionid, gameid } = useParams();
  const context = useContext(StoreContext);
  const [api] = context.api;
  const [, setModalStatus] = context.modalStatus;
  const history = useHistory();

  const [sessionId, setSessionId] = useState(sessionid);
  const [name, setName] = useState('');

  // press Enter key to join session
  const enter = (e) => {
    if (e.key === 'Enter') {
      joinSession();
    }
  }

  // api call function
  const joinSession = async () => {
    console.log(name + ' join session ' + sessionId);
    if (name === '') {
      setModalStatus((status) => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Warning!',
        modalBodyText: 'Sorry, player name can\'t be empty',
        modalColors: 'warning',
      }));
    } else {
      const response = await api.makeAPIRequest(`play/join/${sessionid}`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name,
        }),
      });
      try {
        const json = await response.json();
        if (response.status === 200) {
          console.log(json);
          history.push(`/lobby/${sessionid}/${gameid}/${json.playerId}`);
        } else {
          setModalStatus((status) => ({
            ...status,
            modalActive: true,
            overlayActive: true,
            modalHeaderText: 'Error',
            modalBodyText: json.error,
            modalColors: 'error',
          }));
        }
      } catch (e) {
        console.log('ERROR', e);
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Error',
          modalBodyText: 'Sorry! Can\' connect to the server.',
          modalColors: 'error',
        }));
      }
    }
  };

  return (
    <section>
      <Nav
        visibilities={['false', 'false', 'false', 'true', 'true']}
        exit={() => history.push('/')}
        confirm={joinSession}
      />
      <Main>
        <p>Join session {sessionid}</p>
        <div>
          <TextInput
            name='sessionId'
            label="Session ID"
            value={sessionId}
            onChange={(e) => setSessionId(e.target.value)}
          />
        </div>
        <div>
          <TextInput
            name='playerName'
            label="Player Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={enter}
          />
        </div>
      </Main>
    </section>
  );
};

export default JoinPage;
